import React, { useContext, useEffect, useState } from 'react';
import { ConfigContext } from '../../Context/ConfigContext';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import Swal from 'sweetalert2';
import "../../Styles/custom.css";

const Address = () => {
    const { apiURL, apiHeaderJson } = useContext(ConfigContext);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false)

    const GetCustomerAddress = async () => {
        setLoading(true)
        const headers = apiHeaderJson;
        try {
            const response = await axios.get(`${apiURL}Customers/GetCustomerAddress?limit=1000&page=1`, { headers });
            setData(response.data.data || []);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false)
        }
    };

    const handleDelete = async (customer_address_id) => {
        try {
            const headers = apiHeaderJson;

            let body = {
                customer_address_id: customer_address_id
            };

            const result = await Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
            });

            if (result.isConfirmed) {
                const response = await axios.post(`${apiURL}Customers/DeleteCustomerAddress`, body, { headers });
                if (response.data.success) {
                    GetCustomerAddress();
                    toast.success(response.data.message);
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    const UpdateDefaultAddress = async (customer_address_id, default_address) => {
        if (default_address === 1) {
            toast.warning('This address is already default');
            return;
        }

        try {
            let body = {
                customer_address_id: customer_address_id
            };

            const headers = apiHeaderJson;

            const result = await Swal.fire({
                title: "Are you sure?",
                text: "You want to set this as your default address?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, set it!",
            });

            if (result.isConfirmed) {
                const response = await axios.post(`${apiURL}Customers/UpdateDefaultAddress`, body, { headers });
                if (response.data.success) {
                    GetCustomerAddress();
                    toast.success(response.data.message);
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        GetCustomerAddress();
    }, []);

    return (
        <>
            <ToastContainer />
            <div className="row">
                <div className="col-lg-12">
                    <div className="d-flex justify-content-between align-items-center flex-wrap">
                        <h3 className="mb-0">Billing Address</h3>
                        <Link to="/AddressDetails" className="btn btn-outline-default btn-sm">
                            Create Address
                        </Link>
                    </div>

                    {!data.some(addr => addr.default_address === 1) && !loading && (
                        <div className="alert alert-warning my-3 d-flex justify-content-between align-items-center w-100">
                            <span>No default address.</span>
                        </div>
                    )}

                    <div className='row'>
                        {loading ? (
                            // Show shimmer placeholders while loading
                            Array.from({ length: 2 }).map((_, index) => (
                                <div className="col-md-6 p-3" key={index}>
                                    <div className="shimmer-card">
                                        <div>
                                            <div className="shimmer-line mb-3" style={{ width: '150px', height: '25px' }}></div>
                                            <div className="shimmer-line mb-2" style={{ width: '100px', height: '15px' }}></div>
                                            <div className="shimmer-line mb-2" style={{ width: '300px', height: '15px' }}></div>
                                            <div className="shimmer-line mb-2" style={{ width: '250px', height: '15px' }}></div>
                                            <div className="shimmer-line mb-4" style={{ width: '200px', height: '15px' }}></div>
                                            <div className="shimmer-button"></div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            data?.map((item) => (
                                <div className='col-md-6 p-3' key={item.customer_address_id}>
                                    <div className='address_card'>
                                        <div className='default_address_row'>
                                            <span>{item.default_address === 1 ? 'default' : ''}</span>
                                            <button onClick={() => UpdateDefaultAddress(item.customer_address_id, item.default_address)}>
                                                {item.default_address === 0 && 'Set as default'}
                                            </button>
                                        </div>
                                        <div className="address_details">
                                            <h4>{item.full_name}</h4>
                                            <span>{item.mobile_number}</span>
                                            <p>
                                                {item.area_street_sector}, {item.town_city}, {item.state}, {item.pincode}<br />
                                                {item.country_region}
                                            </p>
                                            <div className='address_btns'>
                                                <Link to={`/AddressDetails/${item.customer_address_id}`} className="btn_address btn-edit">Edit</Link>
                                                <button onClick={() => handleDelete(item.customer_address_id)} className="btn_address btn-delete">Delete</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </>
    );

};

export default Address;
